export const getTotalScansCounterValue = (
	total: number,
	ratePerSecond: number,
	countedAt: string,
): number => {
	const elapsedSeconds = Math.max(
		0,
		(Date.now() - new Date(countedAt).getTime()) / 1000,
	)
	return Math.floor(total + ratePerSecond * elapsedSeconds)
}
